import React from 'react';

import { ReactFCV } from '@types';

import { AddressSkeletonBlock } from './components';
import { StyledWrapper } from './styled';

/**
 * AddressSkeleton Component.
 *
 * This component displays an address skeleton, which is used to show a pre-generated
 * placeholder before specific data is available.
 */
export const AddressSkeleton: ReactFCV = () => (
  <StyledWrapper>
    <AddressSkeletonBlock />
    <AddressSkeletonBlock />
  </StyledWrapper>
);
